import React from "react";

import { Card } from "@/components/ui/card";

import { universityFeaturedCardClassName } from "./universityCardShell";
import {
  UNIVERSITY_HERO_BACKGROUND_HEIGHT,
  UNIVERSITY_HERO_BACKGROUND_SRC,
  UNIVERSITY_HERO_BACKGROUND_WIDTH,
} from "./universityHero";

export function UniversityHeroBanner(): React.ReactElement {
  return (
    <Card
      data-university-featured-card=""
      data-university-hero-banner=""
      className={universityFeaturedCardClassName}
    >
      <div
        data-university-hero-image=""
        className="aspect-[3/1] w-full overflow-hidden rounded-[6px] bg-[image:var(--gradient-primary)]"
      >
        <img
          src={UNIVERSITY_HERO_BACKGROUND_SRC}
          alt="Tessera University"
          width={UNIVERSITY_HERO_BACKGROUND_WIDTH}
          height={UNIVERSITY_HERO_BACKGROUND_HEIGHT}
          decoding="sync"
          fetchPriority="high"
          draggable={false}
          className="block h-full w-full select-none object-contain object-center"
        />
      </div>
    </Card>
  );
}
